import {
  appSync,
  startListening,
  startThrottledListener,
} from '@bonanza-social/toolkit/state';
import {
  fetchShopSales,
  getShopSales,
  selectSalesDataState,
} from './sales.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch, getState }) => {
    const shopSalesDataState = selectSalesDataState(getState());

    if (shopSalesDataState === 'fulfilled') {
      dispatch(fetchShopSales());
    }
  },
});

startThrottledListener({
  actionCreator: fetchShopSales,
  effect: (_, { dispatch }) => {
    dispatch(getShopSales());
  },
});
